import {Part} from "./part";
import DesignNavigationItem from "../../../visComponents/designNavigationItem";
import {PartMenuType} from "../../../visComponents/constants";
import {wallsThumbnail} from "../assets";

import {Shower} from "./shower";
import {ShowerTubCombo} from "./showerTubCombo";
import Shadow from "../subparts/shadow";
import PonyWall from "../subparts/wall/ponyWall";

import WallA from "../subparts/wall/wallA";
import WallB from "../subparts/wall/wallB";
import WallC from "../subparts/wall/wallC";
import WallExR from "../subparts/wall/wallExR";
import WallExL from "../subparts/wall/wallExL";
import ExternallWall from "../subparts/wall/externallWall";
import VanityAccent from "../subparts/wall/vanityAccent";
import store from "../../../../store";

export class Wall extends Part {
  static id = 'Walls';

  constructor() {
    super(true, false, PartMenuType.Complex);

    this.menuType = PartMenuType.Complex;
    this.partName = 'Walls';
    this.translateId = "visualizer.bathroom.walls";
    this.partThumbnail = wallsThumbnail;

    // related items
    this.vanityAccent = null;
    this.wallExR = null;
    this.wallExL = null;
    this.wallA = null;
    this.wallB = null;
    this.wallC = null;
    this.ponyWall = null;
    this.allWallsApplied = true;
  }

  load(dbFeature) {
    let relatedItemName = "",
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "VanityAccent":
        relatedItemName = "vanityAccent";
        RelatedItemClass = VanityAccent;
        break;
      case "WallExtrusion":
      case "EX R":
        relatedItemName = "wallExR";
        RelatedItemClass = WallExR;
        break;
      case "ShowerDivider":
      case "EX L":
        relatedItemName = "wallExL";
        RelatedItemClass = WallExL;
        break;
      case "Wall A":
        relatedItemName = "wallA";
        RelatedItemClass = WallA;
        break;
      case "Wall B":
        relatedItemName = "wallB";
        RelatedItemClass = WallB;
        break;
      case "Wall C":
        relatedItemName = "wallC";
        RelatedItemClass = WallC;
        break;
      case "Pony Wall":
        relatedItemName = "ponyWall";
        RelatedItemClass = PonyWall;
        break;
      case "Shower Shadow":
        if (
          dbFeature.displayName.includes("Shower Shadow - Divider Wall")
          || dbFeature.displayName.includes("Shower Shadow - EX L")
          || dbFeature.displayName.includes("Shower Shadow - EX R")
          || dbFeature.displayName.includes("Shower Shadow - Popout")
          || dbFeature.displayName.includes("Shower Shadow - Pony Wall")
        ) {
          relatedItemName = "shadows";
          RelatedItemClass = Shadow;
        }
        break;
    }
    if (relatedItemName) {
      if (!this[relatedItemName]) {
        this[relatedItemName] = new RelatedItemClass(true);
        if (relatedItemName !== "shadows") {
          this.relatedItems.push(this[relatedItemName]);
        }
      }
      if (!this.categoryEnabled) {
        this.categoryEnabled = true
      }
      if (relatedItemName === "ponyWall") {
        this[relatedItemName].type = Shower.Type.Custom;
      }
      this[relatedItemName].getParent = () => this;
      this[relatedItemName].load(dbFeature);
      return true
    }
    return false
  }

  setLayers(layout, placeholdersNeeded) {
    let res = [];
    this.relatedItems.forEach(relatedItem => {
      relatedItem.setLayers(layout);
      (placeholdersNeeded && !relatedItem.placeholderChanged && relatedItem.placeholderFeature)
        ? relatedItem.placeholderFeature.layer.addTo(res)
        : relatedItem.activeFeature ? relatedItem.activeFeature.layer.addTo(res) : null;
      if (relatedItem.shadowFeature) {
        relatedItem.shadowFeature.layer.addTo(res)
      }
    });
    return res.length ? res : null;
  }

  navigationItem() {
    return new DesignNavigationItem('Walls', this);
  }

  isSubTypeWithItems() {
    return false;
  }

  subParts() {

    const activeShowerGroup = this.getActiveShowerGroup();
    const ponyWallIsActive = activeShowerGroup.showerDimensions() === "Pony";

    const shower = this.layout.parts[Shower.id];
    // const vanityAccent = this.layout.parts[Vanity.id].vanityAccent;
    return this.relatedItems.filter(item => {
      if (item.isPonyWallPart) {
        item.visible = ponyWallIsActive
      }
      return item.visible
    }).filter(item => item && item.visible).filter((relatedItem) => {
      return !(shower.isComplete() &&
        (relatedItem instanceof WallExL
          || (relatedItem instanceof WallExR && shower.showerBody && !shower.showerBody.activeFeature.partName.includes("Complete"))))
    }).map(_ => new DesignNavigationItem(_.partName, _));
  }

  setDefault(layout) {
    this.relatedItems.forEach(_ => _.setDefault(layout));
  }

  handleSubPartClick() {

  }

  recoverPrevioslySelected(activeRelatedPart) {
    const {activeQuoteIndex} = store.getState().quotesState;
    this.relatedItems.forEach(relatedItem => {
      if (relatedItem.partId !== activeRelatedPart.partId && relatedItem.activeFeatureBeforeAllWalls) {
        if (relatedItem.activeFeatureBeforeAllWalls === "placeholder") {
          relatedItem.placeholderChanged = false;
          relatedItem.firstClick[activeQuoteIndex] = false;
          if (relatedItem instanceof ExternallWall) { // there shouldn't be cases for this, but nevertheless, just in case
            relatedItem.selectedByUser = false
          }
        } else {
          if (!(relatedItem instanceof ExternallWall && relatedItem.selectedByUser)) {
            relatedItem.activeFeatureBeforeAllWalls.clickFromAllWalls();
          }
        }
      }
    });
  }

  showerTubComboIsActive() {
    const comboPart = this.layout.parts[ShowerTubCombo.id];
    return comboPart && comboPart.showerTubComboIsActive
  }

  getActiveShowerGroup() {
    return this.showerTubComboIsActive() ? this.layout.parts[ShowerTubCombo.id] : this.layout.parts[Shower.id];
  }

}
